import parse from 'html-react-parser';
import moment from 'moment';

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import axios from '../../../services/MyAxios';
import BonusSummary from '../../elements/Bonuses/BonusSummary';
import { CRM_PERMISSION } from "../Helpers/CrmPermissions";
import ActionButton from "../../../elements/ActionButton";

function FreespinCampaignShow() {
    const { id } = useParams();
    const [campaign, setCampaign] = useState({
        title: '',
        currency_code: '',
        casino_game: { creator_name: '', slug: '', name: '' },
        quantity_per_user: 1,
        creator_name: '',
        min_deposit: 0,
        bet_option_id: 0,
        denomination: 0,
        wagering_requirement: 0,
        count_of_days_to_fill_requirements_by_user: 1,
        available_from: '',
        available_to: '',
        additional_data: [],
        description: '',
    });

    useEffect(() => {
        axios.get(`/crea/casino/api/freespin-campaigns/${id}`).then((response) => {
            setCampaign(response.data);
        });
    }, []);

    return (
        <div className="card">
            <div className="card-header">Freespin campaign details</div>
            <div className="card-body table-responsive">
                <table className="table">
                    <thead />
                    <tbody>
                        <tr key="id">
                            <th width="30%">ID</th>
                            <td>{campaign.id}</td>
                        </tr>
                        <tr key="name">
                            <th width="30%">Name</th>
                            <td>{campaign.name}</td>
                        </tr>
                        <tr key="currency">
                            <th width="30%">Currency</th>
                            <td>{campaign.currency_code}</td>
                        </tr>
                        <tr key="game">
                            <th width="30%">Game</th>
                            <td>
                                {campaign.casino_game.creator_name} | {campaign.casino_game.name}
                            </td>
                        </tr>
                        <tr key="game_slug">
                            <th width="30%">Game slug</th>
                            <td>{campaign.casino_game.slug}</td>
                        </tr>
                        <tr key="quantity_per_user">
                            <th width="30%">Quantity per user</th>
                            <td>{campaign.quantity_per_user}</td>
                        </tr>
                        <tr key="min_deposit">
                            <th width="30%">Min deposit</th>
                            <td>{campaign.min_deposit}</td>
                        </tr>
                        <tr key="bet_option_id">
                            <th width="30%">Bet option id</th>
                            <td>{campaign.bet_option_id}</td>
                        </tr>
                        <tr key="denomination">
                            <th width="30%">Denomination</th>
                            <td>{campaign.denomination}</td>
                        </tr>
                        <tr key="lines">
                            <th width="30%">Lines</th>
                            <td>{campaign.lines}</td>
                        </tr>
                        <tr key="bet_per_line">
                            <th width="30%">Bet per line</th>
                            <td>{campaign.bet_per_line}</td>
                        </tr>
                        <tr key="wagering_requirement">
                            <th width="30%">Wagering requirement</th>
                            <td>{campaign.wagering_requirement}</td>
                        </tr>
                        <tr key="count_of_days_to_fill_requirements_by_user">
                            <th width="30%">Count of days to fill requirements by user</th>
                            <td>{campaign.count_of_days_to_fill_requirements_by_user}</td>
                        </tr>
                        <tr key="available_from">
                            <th width="30%">Available from</th>
                            <td>{moment.utc(campaign.available_from).format('YYYY-MM-DD HH:mm (z)')}</td>
                        </tr>
                        <tr key="available_to">
                            <th width="30%">Available to</th>
                            <td>{moment.utc(campaign.available_to).format('YYYY-MM-DD HH:mm (z)')}</td>
                        </tr>
                        <tr key="description">
                            <th width="30%">Description</th>
                            <td>{parse(campaign.description)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <BonusSummary bonusId={parseInt(id)} bonusType="casino freespin campaign" />
            <div className="card-footer">
                <ActionButton
                    url={`/freespin-campaigns/${campaign.id}/edit`}
                    title="Edit bonus"
                    permissions={[CRM_PERMISSION.CASINO_FREESPIN_CAMPAIGNS_EDIT]}
                />
            </div>
        </div>
    );
}

export default FreespinCampaignShow;
